/** Artifact positions — create view (delegates to the shared form). */
import { ArtifactPositionForm } from "./_ArtifactPositionForm";

export function ArtifactPositionCreate() {
  return <ArtifactPositionForm action="create" />;
}

export default ArtifactPositionCreate;
